import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ setUserdata, userdata, imageList, setAddressInfo }) => {
  const [form, setForm] = useState(false)
  let [activeImg, setActiveImg] = useState(1)
  // const nav =useNavigate()


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserdata(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOnClick = (index) => {
    setActiveImg(index);
    setAddressInfo((index - 1))
    // nav("/", { state: { selectedImage: imageurl } });
  };
  return (
    <div>
      <ul className="nav nav-tabs nav-justified">
        <li className="nav-item" onClick={() => { setForm(false) }}>
          <a className={`nav-link cursor-pointer  ${!form ? "active" : ""} `} aria-current="page">Template</a>
        </li>
        <li className="nav-item" onClick={() => { setForm(true) }}>
          <a className={`nav-link  cursor-pointer ${form ? "active" : ""} `} aria-current="page">Data</a>
        </li>
      </ul>
      <div className='tab-content'>
        {/* <div className={`fade-container tab-content ${form ? 'fade-in' : 'fade-out'}`}> */}
        {form ? (
          <div className='tab-pane fade active show '>
            <div className='form-group'>
              <label className='Lable' >Name</label>
              <input
                className='form-control mb-3'
                type="text"
                placeholder='Enter Name'
                name='name'
                onChange={handleChange}
                value={userdata.name}

              />
            </div>
            <div className='form-group'>
              <label className='Lable'>Position</label>
              <input
                className='form-control mb-3'
                type="text"
                placeholder='Enter Position'
                name='position'
                onChange={handleChange}
                value={userdata.position}

              />
            </div>

            <div className='form-group'>
              <label className='Lable'>Mobile</label>
              <input
                className='form-control mb-3'
                type="text"
                placeholder='Enter Number'
                name='number'
                onChange={handleChange}
                value={userdata.number}

              />
            </div>



          </div>
        ) : (
          <>
            <div className='tab-pane fade show active contact-info'>
              <h1 className='h1 text-center m-2' style={{ fontSize: "1.3rem" }}>Select Your Template</h1>
              {imageList.map((obj, index) => {
                let { title, addressone, phonenumber } = obj
                return <div className={`cursor-pointer temp p-2 mb-2 text-start ${activeImg === (index + 1) ? "active" : ""} `} key={index} onClick={() => {
                  handleOnClick((index + 1))
                }}>
                  <div className='' style={{ marginLeft: 5 }}>
                    <h6 className='header-text'>{title}</h6>
                  </div>
                  <div className='d-flex address-info'>
                    <div className='px-2'>
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                    </div>
                    <div className='text-start'>
                      <p className='p-text'>
                        {addressone}
                      </p>
                    </div>
                  </div>
                  <div className='d-flex phone-info'>
                    <div className='px-2'><i className="fa fa-phone"></i></div>
                    <div><p className='p-text'>{phonenumber}</p></div>
                  </div>
                </div>
              })}
            </div>
          </>)}
      </div>
    </div>
  )
}

export default Sidebar
